module.exports = __webpack_public_path__ + "media/images/icons/paycard-3a25c580194bb13a7a5d98bfbf682dcb.svg";